import { configureStore } from '@reduxjs/toolkit';
import { EndPoints}  from '../constants/api-config';
import logger from 'redux-logger';

import account from './account';
import facturation from './facturation';

export const store = configureStore({
    reducer: {
        account,
        facturation
    },
    devTools: EndPoints.environment === 'development',
    middleware: (getDefaultMiddleware) => {
        let options = { serializableCheck: false };
        if (EndPoints.environment !== 'production')
            return getDefaultMiddleware(options).concat(logger);

        return getDefaultMiddleware(options);
    }
});

export default store;